//angular
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
//app
import { AuthGuardService } from '../../_guard/auth.guard';
import { DashboardComponent} from './dashboard/dashboard.component';
import { LayoutBaseComponent } from './layout.component';
import { Role } from '../../_shared/models/role.model';
// used for the new designs
import { LayoutBaseNewComponent } from './layout-new.component';

const MainRoutes: Routes = [
  // {
  //   path: '',
  //   component: LayoutBaseNewComponent,
  //   children: [
      //dashboard
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuardService],
        data: { roles: [Role.owner, Role.admin] }
      },
      //analytics
      {
        loadChildren: () => import('./analytics/analytics.module').then(m => m.AnalyticsModule),
        path: 'analytics',
        pathMatch: 'prefix'
      },
      //customers
      {
        loadChildren: () => import('./customers/customers.module').then(m => m.CustomersModule),
        path: 'customers',
        pathMatch: 'prefix'
      },
      //integrations
      {
        loadChildren: () => import('./integrations/integrations.module').then(m => m.IntegrationsModule),
        path: 'integrations',
        pathMatch: 'prefix'
      },
      //invoices
      {
        loadChildren: () => import('./invoices/invoices.module').then(m => m.InvoicesModule),
        path: 'invoices',
        pathMatch: 'prefix'
      },
      //logs
      {
        loadChildren: () => import('./transactions/transactions.module').then(m => m.TransactionsModule),
        path: 'transactions',
        pathMatch: 'prefix'
      },
      //products
      {
        loadChildren: () => import('./products/products.module').then(m => m.ProductsModule),
        path: 'products',
        pathMatch: 'prefix'
      },
      //settings
      {
        loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule),
        path: 'settings',
        pathMatch: 'prefix'
      },
      //subscriptions
      {
        loadChildren: () => import('./subscriptions/subscriptions.module').then(m => m.SubscriptionsModule),
        path: 'subscriptions',
        pathMatch: 'prefix'
      },
      {
        loadChildren: () => import('./upcoming-charges/upcoming-charges.module').then(m => m.UpcomingChargesModule),
        path: 'upcoming-charges',
        pathMatch: 'prefix'
      },
  {
    loadChildren: () => import('./leads/leads.module').then(m => m.LeadsModule),
    path: 'leads',
    pathMatch: 'prefix'
  },
      //default
      // {
      //   path: '',
      //   pathMatch: 'prefix',
      //   redirectTo: 'dashboard'
      // },
  //   ]
  // },
];

@NgModule({
  exports: [
    RouterModule
  ],
  imports: [
    RouterModule.forChild(MainRoutes)
  ]
})

export class MainRoutingModule {
  constructor() {
    console.log(`main.routing.ts was loaded.`)
  }
}
